// Splits upgrade plans into the two dialog "pages". Operates on the mapped card
// shape from mapPlanToCard ({ name, code, ... }). A plan is Community when its
// name or code contains "community" or "basic"; everything else (grow,
// professional, enterprise, …) is Business & Enterprise.
export const PLAN_CATEGORY = {
    BUSINESS: 'business',
    COMMUNITY: 'community',
};

const COMMUNITY_PATTERN = /community|basic/;

export function getPlanCategory (plan) {
    const haystack = `${plan.name || ''} ${plan.code || ''}`.toLowerCase();
    return COMMUNITY_PATTERN.test(haystack) ? PLAN_CATEGORY.COMMUNITY : PLAN_CATEGORY.BUSINESS;
}
